
import Overlay from '@/components/Overlay.vue';
import NoAccess from '@/components/NoAccess.vue';
import { BarChart } from 'echarts/charts';
import { GridComponent } from 'echarts/components';
import { use } from 'echarts/core';
import { CanvasRenderer, SVGRenderer } from 'echarts/renderers';
import { defineComponent, PropType } from 'vue';
import VChart from 'vue-echarts';
import { IMonthTotals } from '@/modules/dashboardBrandManagement/types';

use([BarChart, CanvasRenderer, SVGRenderer, GridComponent]);

export default defineComponent({
  name: 'DashboardMonthTotals',

  components: {
    VChart,
    Overlay,
    NoAccess,
  },

  props: {
    monthTotals: {
      type: Object as PropType<IMonthTotals>,
      default: () => ({}),
    },

    salesChannelName: {
      type: String,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    access: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      options: {
        grid: {
          top: '0%',
          bottom: '30%',
          left: '0%',
          right: '-2.3%',
        },
        xAxis: {
          show: false,
          type: 'value',
        },
        yAxis: {
          show: false,
          type: 'category',
          data: ['Totals'],
        },
      },
    };
  },

  methods: {
    setOptionsChart() {
      const borderRadius: number[] =
        this.monthTotals.channelBalanceValueTotals <= 0
          ? [0, 4, 4, 0]
          : [0, 0, 0, 0];

      (this.$refs['chart'] as any).setOption({
        grid: {
          top: '0%',
          bottom: '30%',
          left: '0%',
          right: '0%',
        },
        xAxis: {
          show: false,
          type: 'value',
          max: (value) => value.max,
        },
        yAxis: {
          show: false,
          type: 'category',
          data: ['Totals'],
        },
        series: [
          {
            name: 'Revenue Value',
            type: 'bar',
            stack: 'total',
            barWidth: '35px',
            itemStyle: {
              color: '#FF9050',
              borderRadius: [4, 0, 0, 4],
            },
            label: {
              show: false,
            },
            emphasis: {
              focus: 'series',
            },
            data: [this.monthTotals.channelRevenueValue],
          },
          {
            name: 'Invoice Value',
            type: 'bar',
            stack: 'total',
            itemStyle: {
              color: '#FFD337',
              borderRadius: borderRadius,
            },
            label: {
              show: false,
            },
            emphasis: {
              focus: 'series',
            },
            data: [this.monthTotals.channelInvoiceValue],
          },
          {
            name: 'Balance Value',
            type: 'bar',
            stack: 'total',
            itemStyle: {
              color: '#E70024',
              borderRadius: [0, 4, 4, 0],
            },
            label: {
              show: false,
            },
            emphasis: {
              focus: 'series',
            },
            data: [
              this.monthTotals.channelBalanceValueTotals <= 0
                ? 0
                : this.monthTotals.channelBalanceValueTotals,
            ],
          },
        ],
      });
    },
  },

  watch: {
    monthTotals: {
      handler() {
        this.setOptionsChart();
      },
      deep: true,
    },
  },
});
